// extracted by mini-css-extract-plugin
export default {"info-video":"styles_info-video__EVh3u","info-video__icon":"styles_info-video__icon__yYItl","slick-height":"styles_slick-height__s0Lcm"};